<template>
    <div class="md-layout">
        <review-section label="1. Project Information" />
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <p class="text-primary form-subsection-title">Project Title</p>
            <p class="text-primary">{{application.project.title}}</p>
            <p class="text-primary form-subsection-title">Project Abstract</p>
            <p class="text-primary">{{application.project.abstract}}</p>
        </div>
        <review-dataline label="Project Start Date" :value="application.project.start_date" />
        <review-dataline label="Project End Date" :value="application.project.end_date" />
        <review-dataline label="Research Field"
            :value="getDataName(application.project.research_field, data_settings.research_field_list)" />
        <review-dataline label="Other Research Fields" :value="application.project.other_research_field" />
        <review-dataline label="Expected Output"
            :value="getDataName(application.project.expected_output, data_settings.expected_output_list)" />
        <review-dataline label="Other Expected Output" :value="application.project.other_expected_output" />


        <review-section label="2. Researcher Information" />
        <review-dataline label="Main Researcher Name" :value="application.researcher.main_researcher" />
        <review-dataline label="Institution" :value="application.researcher.institution" />
        <review-dataline label="Position" :value="application.researcher.position" />
        <review-dataline label="Address" :value="application.researcher.address" />
        <review-dataline label="Phone Number" :value="application.researcher.phone" />
        <review-dataline label="E-mail Address" :value="application.researcher.email" />
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <p class="text-primary form-subsection-title">Team Member</p>
        </div>
        <div class="application-table-container">
            <table class="application-table">
                <tr class="application-tr">
                    <td class="application-td-head">No.</td>
                    <td class="application-td-head">Name</td>
                    <td class="application-td-head">Institution</td>
                    <td class="application-td-head">Position</td>
                    <td class="application-td-head">E-mail Address</td>
                </tr>
                <tr class="application-tr" v-for="(team_member, i) in application.researcher.team_member_list">
                    <td class="application-td td-padding td-center">{{i+1}}</td>
                    <td class="application-td td-padding">{{team_member.name}}</td>
                    <td class="application-td td-padding">{{team_member.institution}}</td>
                    <td class="application-td td-padding">{{team_member.position}}</td>
                    <td class="application-td td-padding">{{team_member.email}}</td>
                </tr>
            </table>
        </div>


        <review-section label="3. HPC Resource Request" />
        <review-dataline label="CPU Computing" :value="getDataName(application.resource.cpu, data_settings.cpu_list)" />
        <review-dataline label="GPU Computing" :value="getDataName(application.resource.gpu, data_settings.gpu_list)" />
        <review-dataline label="RAM" :value="getDataName(application.resource.ram, data_settings.ram_list)" />
        <review-dataline label="Storage"
            :value="getDataName(application.resource.storage, data_settings.storage_list)" />
        <review-dataline label="Operating System"
            :value="getDataName(application.resource.os, data_settings.os_list)" />
        <review-dataline label="Request Duration"
            :value="getDataName(application.resource.duration, data_settings.duration_list)" />
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <p class="text-primary form-subsection-title">Pre-Installed Software or Other Requests</p>
            <p class="text-primary">{{application.resource.software || "Not Available"}}</p>
        </div>

        <review-section label="4. Attachment" />
        <review-fileline label="1. SSH Public Key" :file="application.attachment.ssh_key" />
        <review-fileline label="2. Research Related Documents" :file="application.attachment.other_document"
            v-if="String(application.attachment.other_document.url).length >0" />
    </div>
</template>
<script>
    export default {
        props: { data: {} },
        data() {
            return {
                application: null,
                data_settings: {
                    research_field_list: [
                        { id: 1, name: "Biology" },
                        { id: 2, name: "Chemistry" },
                        { id: 3, name: "Computer Science" },
                        { id: 4, name: "Material Science" },
                        { id: 5, name: "Mathematics" },
                        { id: 6, name: "Physics" },
                        { id: 99, name: "Other" }
                    ],
                    expected_output_list: [
                        { id: 1, name: "Publication" },
                        { id: 2, name: "Patent" },
                        { id: 3, name: "Prototype" },
                        { id: 4, name: "Income" },
                        { id: 5, name: "Impact" },
                        { id: 99, name: "Other" }
                    ],
                    cpu_list: [
                        { id: 1, name: "1 CPU cores" },
                        { id: 2, name: "2 CPU cores" },
                        { id: 4, name: "4 CPU cores" },
                        { id: 8, name: "8 CPU cores" },
                        { id: 16, name: "16 CPU cores" },
                        { id: 32, name: "32 CPU cores" },
                        { id: 64, name: "64 CPU cores" },
                        { id: 128, name: "128 CPU cores" }
                    ],
                    gpu_list: [
                        { id: 1, name: "Not Use" },
                        { id: 2, name: "NVIDIA Tesla K80 24GB (12GBx2) RAM" },
                        { id: 3, name: "NVIDIA Tesla A40 48GB RAM" },
                    ],
                    ram_list: [
                        { id: 1, name: "1 GB" },
                        { id: 2, name: "2 GB" },
                        { id: 4, name: "4 GB" },
                        { id: 8, name: "8 GB" },
                        { id: 16, name: "16 GB" },
                        { id: 32, name: "32 GB" },
                        { id: 64, name: "64 GB" },
                        { id: 128, name: "128 GB" },
                        { id: 256, name: "256 GB" },
                        { id: 512, name: "512 GB" }
                    ],
                    storage_list: [
                        { id: 10, name: "10 GB" },
                        { id: 30, name: "30 GB" },
                        { id: 50, name: "50 GB" },
                        { id: 100, name: "100 GB" },
                        { id: 200, name: "200 GB" },
                        { id: 300, name: "300 GB" },
                        { id: 500, name: "500 GB" },
                        { id: 800, name: "800 GB" },
                        { id: 1000, name: "1000 GB" },
                        { id: 2000, name: "2000 GB" },
                        { id: 5000, name: "5000 GB" }
                    ],
                    os_list: [
                        { id: 10, name: "Ubuntu 24.04 LTS" },
                        { id: 20, name: "Ubuntu 22.04 LTS" },
                        { id: 30, name: "Ubuntu 20.04 LTS" },
                        { id: 40, name: "Debian 12" },
                        { id: 50, name: "Debian 11" },
                        { id: 60, name: "Rocky Linux 9" },
                        { id: 61, name: "CentOS Stream 9" },
                        { id: 70, name: "Windows Server 2019" },
                        { id: 80, name: "Windows Server 2022" }
                    ],
                    duration_list: [
                        { id: 7, name: "7 Days" },
                        { id: 14, name: "14 Days" },
                        { id: 30, name: "1 Month" },
                        { id: 60, name: "2 Months" },
                        { id: 90, name: "3 Months" }
                    ]
                }
            }
        },
        created() {
            this.application = JSON.parse(this.data.form_data);
        }
    }
</script>


// WEBPACK FOOTER //
// src/forms/HPC_FORM.vue